import { EVENT_KEYS } from './constants';
const noop = () => undefined;
export default function useDropdownMenuKeyboardNav(_ref) {
  let {
    buttonRef,
    focusedElement,
    currentIndex,
    disableDeselect = true,
    event,
    onBlur = noop,
    options = [],
    selectedIndex,
    setDropdownMenuVisible = noop,
    setFocusIndex = noop,
    setSelectedIndex = noop,
    setTypedValue = noop
  } = _ref;
  if ((event === null || event === void 0 ? void 0 : event.key) === EVENT_KEYS.tab) {
    setFocusIndex(undefined);
    setDropdownMenuVisible(false);
    return;
  }
  event === null || event === void 0 ? void 0 : event.preventDefault();
  (event === null || event === void 0 ? void 0 : event.key) === EVENT_KEYS.arrow_down && (event === null || event === void 0 ? void 0 : event.stopPropagation());
  const button = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current;
  const minIndex = !disableDeselect && selectedIndex ? -1 : 0;
  const maxIndex = options.length;
  const isTopPosition = (currentIndex === null || currentIndex === void 0 ? void 0 : currentIndex.renderIndex) === minIndex;
  const actions = {
    up: {
      valid: [EVENT_KEYS.arrow_up, EVENT_KEYS.arrow_left].includes(event === null || event === void 0 ? void 0 : event.key) && currentIndex !== undefined && currentIndex.renderIndex >= minIndex,
      handler: () => {
        isTopPosition ? (() => {
          if ((event === null || event === void 0 ? void 0 : event.key) === EVENT_KEYS.arrow_up || (event === null || event === void 0 ? void 0 : event.key) === EVENT_KEYS.arrow_left) return;
          setFocusIndex && setFocusIndex(undefined);
          (button === null || button === void 0 ? void 0 : button.focus) && button.focus();
        })() : (() => {
          setFocusIndex !== undefined && setFocusIndex({
            renderIndex: currentIndex === undefined ? minIndex : currentIndex.renderIndex - 1,
            keyboard: true,
            behavior: 'smooth'
          });
        })();
      }
    },
    down: {
      valid: [EVENT_KEYS.arrow_down, EVENT_KEYS.arrow_right].includes(event === null || event === void 0 ? void 0 : event.key) && currentIndex !== undefined && currentIndex.renderIndex + 1 < maxIndex,
      handler: () => currentIndex !== undefined && setFocusIndex({
        renderIndex: currentIndex.renderIndex + 1,
        keyboard: true,
        behavior: 'smooth'
      })
    },
    select: {
      valid: [EVENT_KEYS.enter, EVENT_KEYS.space].includes(event === null || event === void 0 ? void 0 : event.key),
      handler: () => {
        var _focusedElement$curre;
        if ((currentIndex === null || currentIndex === void 0 ? void 0 : currentIndex.renderIndex) === -1) {
          setSelectedIndex(undefined);
          setFocusIndex(undefined);
        } else if ((currentIndex === null || currentIndex === void 0 ? void 0 : currentIndex.renderIndex) === selectedIndex) {
          setDropdownMenuVisible(false);
        } else {
          setSelectedIndex(options.filter(opt => opt.renderIndex === (currentIndex === null || currentIndex === void 0 ? void 0 : currentIndex.renderIndex))[0].selectionIndex);
        }
        setTypedValue('');
        // this blur assists with removing tooltip on selection with space bar
        focusedElement === null || focusedElement === void 0 ? void 0 : (_focusedElement$curre = focusedElement.current) === null || _focusedElement$curre === void 0 ? void 0 : _focusedElement$curre.blur();
        onBlur();
      }
    },
    exit: {
      valid: [EVENT_KEYS.escape].includes(event === null || event === void 0 ? void 0 : event.key),
      handler: () => {
        setFocusIndex(undefined);
        setDropdownMenuVisible(false);
      }
    },
    home: {
      valid: [EVENT_KEYS.home].includes(event === null || event === void 0 ? void 0 : event.key),
      handler: () => setFocusIndex({
        behavior: 'auto',
        keyboard: true,
        renderIndex: selectedIndex !== undefined && !disableDeselect ? -1 : 0
      })
    },
    end: {
      valid: [EVENT_KEYS.end].includes(event === null || event === void 0 ? void 0 : event.key),
      handler: () => setFocusIndex({
        behavior: 'auto',
        keyboard: true,
        renderIndex: options.length - 1
      })
    }
  };
  Object.keys(actions).forEach(key => actions[key].valid && actions[key].handler());
}